export default __webpack_public_path__ + "static/media/first-order.61693e2b.png";